import { Tabs } from "antd";
import SectionWrapper from "../../components/SectionWrapper";

const MyProjects = () => {
    return (
        <SectionWrapper className="my-5">
            <div className="font-18 text-theme fw-bold">My Projects</div>
            <Tabs defaultActiveKey="1">
                <Tabs.TabPane tab="Website" key="1">
                    <p className="text-theme">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi quaerat quis ipsa ex. Sapiente,
                        reprehenderit quo esse ex tenetur sequi vel dolores voluptatibus pariatur cum, rerum,
                        repellendus neque possimus nulla?
                    </p>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Mobile Apps" key="2" disabled={true}>
                    Coming Soon
                </Tabs.TabPane>
            </Tabs>
        </SectionWrapper>
    );
};

export default MyProjects;
